import { useState, useEffect } from "react"
import { loadGoogleMaps, isGoogleMapsReady } from "../utils/loadGoogleMaps"

export const useMapsReady = () => {
  const [mapsReady, setMapsReady] = useState(() => isGoogleMapsReady())

  useEffect(() => {
    // Check immediately — Maps may already be loaded
    if (isGoogleMapsReady()) {
      setMapsReady(true)
      return
    }

    // Poll every 200ms — handles case where event fired before mount
    const interval = setInterval(() => {
      if (isGoogleMapsReady()) {
        setMapsReady(true)
        clearInterval(interval)
      }
    }, 200)

    // Also listen for event (for fresh loads)
    const onReady = () => {
      setMapsReady(true)
      clearInterval(interval)
    }
    window.addEventListener("googleMapsReady", onReady)

    // Trigger load if not started yet
    loadGoogleMaps()
      .then(() => { setMapsReady(true); clearInterval(interval) })
      .catch(() => { setMapsReady(true); clearInterval(interval) })

    return () => {
      clearInterval(interval)
      window.removeEventListener("googleMapsReady", onReady)
    }
  }, [])

  return mapsReady
}